export const articles = [
  {
    id: 'ultimate-guide',
    title: 'CSSBuy Spreadsheet Ultimate Guide 2026',
    summary: 'Everything you need to know about finding, using, and maximizing CSSBuy spreadsheets for the best shopping experience. From beginner basics to advanced tips.',
    slug: 'cssbuy-spreadsheet-ultimate-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20with%20laptop%20displaying%20spreadsheet%20on%20screen%2C%20soft%20natural%20light%2C%20clean%20cream%20background%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20simple%20elegant%20composition&width=1000&height=562&seq=article-guide-01&orientation=landscape',
    featured: true,
  },
  {
    id: 'comparison',
    title: 'CSSBuy vs Kakobuy Spreadsheet Comparison',
    summary: 'A detailed side-by-side comparison of CSSBuy and Kakobuy spreadsheets. Find out which agent service offers better lists, pricing, and user experience.',
    slug: 'cssbuy-vs-kakobuy-spreadsheet',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20minimalist%20product%20cards%20side%20by%20side%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20comparison%20concept%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20simple%20composition&width=800&height=600&seq=article-compare-02&orientation=landscape',
    featured: false,
  },
  {
    id: 'safety',
    title: 'Is CSSBuy Spreadsheet Safe? Complete Safety Guide',
    summary: 'Learn how to identify verified spreadsheets, avoid scam links, and shop safely using CSSBuy agent services. Your complete safety checklist inside.',
    slug: 'cssbuy-spreadsheet-safety-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20shield%20and%20lock%20concept%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20safety%20and%20security%20theme%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20simple%20elegant%20composition&width=800&height=600&seq=article-safety-03&orientation=landscape',
    featured: false,
  },
];